import styled from 'styled-components'

export const ContainerLoading = styled.div`
    flex: auto;
    display: flex;
`

export const Container = styled.div`
    flex: auto;
    overflow: auto;

    &::-webkit-scrollbar-track {
        background-color: #FFF;
    }

    &::-webkit-scrollbar {
        width: 5px;
    }

    &::-webkit-scrollbar-thumb {
        background: #C3C3C3;
        border-radius: 4px;
    }

    scrollbar-width: thin;
    scrollbar-color: #C3C3C3;
    scrollbar-track-color: #FFF;

    .seeMore{
        position: absolute;
        top: 0.5rem;
        left: 0.2rem;
        font-size: 1.4rem;
        display: flex;
        color: var(--colorFontsCardsDashboard);

        @media (min-width: 960px){
            cursor: pointer;
        }
    }
`

export const Content = styled.div`
    margin-bottom: 2.5rem;
`

export const Groups = styled.div`
    color: var(--colorFontsCardsDashboard);
    padding: 1rem 0;
    width: 100%;

    h3{
        margin: 0 0.5rem;
    }
`;

export const TableProducts = styled.table`
    color: var(--colorFontsCardsDashboard);
    padding: 1rem 0;
    border-collapse: collapse;
    margin: 25px 0;
    font-size: 1rem;
    width: 100%;


    thead{
        tr{
            background: var(--colorBackgroundCardsDashboard);
            text-align: right;

            th:first-child{
                text-align: left;
            }

            th{
                width: 25%;
            }

            th:nth-child(2){
                border-style: solid;
                border-color: #ccc;
                border-left-width: 0;
                border-top-width: 0;
                border-bottom-width: 0;
                border-right-width: 1px;
            }

            th:nth-child(3){
                text-align: left;
            }
        }
    }


    tbody{
        tr{
            border-bottom: 1px solid #DDD;
            text-align: right;
            
            td{
                width: 25%;

                p{
                    margin-top: 10px;
                    text-decoration: underline;
                }
            }
            
            td:first-child{
                text-align: left;
                width: 30%;
            }

            td:nth-child(2){
                border-style: solid;
                border-color: #ccc;
                border-left-width: 0;
                border-top-width: 0;
                border-bottom-width: 0;
                border-right-width: 1px;
            }

            td:nth-child(3){
                text-align: left;
            }

            &:nth-child(even){
                background: #f2f2f2;
            }

            &:last-of-type{
                background: #CCC;
                color: black;
                font-weight: 500;
            }
        }
    }


    th, td{
        padding: 0.7rem 0.9rem;
      
    } 
`